import { api } from './authService';

export const pushService = {
    async registerSW() {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn('Push уведомления не поддерживаются');
        return null;
      }
  
      const registration = await navigator.serviceWorker.register('/sw.js');
      return registration;
    },
  
    async subscribe(publicKey) {
      const registration = await navigator.serviceWorker.ready;
  
      let subscription = await registration.pushManager.getSubscription();
      if (subscription) return subscription;
  
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
      });
  
      return subscription;
    },
  
    async sendSubscriptionToBackend(subscription) {
      await api.post('/push/subscribe', {
        endpoint: subscription.endpoint,
        p256DH: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')))),
        auth: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('auth')))),
        expirationTime: subscription.expirationTime || null
      });
    }
  };
  
  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }